import React from 'react';
import { Paper, Tooltip } from '@material-ui/core';

// Manufacturer share-of-scans as horizontal bars (top 10). Lightweight CSS
// bars instead of a chart so it reads at a glance next to the momentum panel.
const ManufacturerShare = ({ manufacturers }) => {
  const list = (manufacturers || []).slice(0, 10);
  const total = (manufacturers || []).reduce((s, m) => s + m.views, 0);
  const max = list.length ? list[0].views : 0;

  return (
    <Paper className="insights__card insights__col-6" variant="outlined">
      <div className="insights__card-head">
        <span className="insights__card-title">Top Manufacturers</span>
        <span className="insights__card-sub">share of scans</span>
      </div>
      {list.length === 0 ? (
        <div className="insights__empty">No scans in this period.</div>
      ) : (
        list.map((m) => {
          const pct = total ? (m.views / total) * 100 : 0;
          return (
            <div className="insights__bar-row" key={m.manufacturer_name}>
              <Tooltip title={m.manufacturer_name || 'Unknown'}>
                <span className="insights__bar-name">
                  {m.manufacturer_name || 'Unknown'}
                </span>
              </Tooltip>
              <span className="insights__bar-track">
                <span
                  className="insights__bar-fill"
                  style={{ width: `${max ? (m.views / max) * 100 : 0}%` }}
                />
              </span>
              <span className="insights__bar-val">
                {m.views} ({pct.toFixed(0)}%)
              </span>
            </div>
          );
        })
      )}
    </Paper>
  );
};

export default ManufacturerShare;
